import React, { useState } from "react";
import { Button, Typography, List, ListItem, ListItemText, Box } from "@mui/material";
import CommonDialog from "./Dialog"; // Adjust the import path as necessary

const termsAndConditions = [
  "We calculate a day 24hrs cycle from 09:00am to 09:00am. Beyond 09:30am, full day rent is applicable.",
  "We follow a 2 days minimum hire policy.",
  "Driver fees for delivery & pickup will depend on the location.",
  "Airport parking charges (if any) must be paid by the hirer.",
  "The hirer must have a two years valid Indian Driving License or a Driving Permit if they have an International Driving License.",
  "Advance payment of a minimum ₹3,000/- is required to book the vehicle; the rest can be paid at the time of delivery or the full amount can be paid in advance.",
  "One original photo ID (Aadhaar/EPIC/DL of spouse/friend) must be submitted with us towards security. This will be returned upon returning the car.",
  "Fuel must be returned at the same level as received on day 01 (no refund for extra fuel).",
  "Cars must be driven within Goa only. Call us for outstation.",
  "The cars are for use only on-road driving and not for off-road driving.",
  "Any vehicle damage from an outside party, the hirer will be liable to pay the damages incurred.",
  "Seat belts must be worn at all times by the driver. Drinking and driving is not permitted.",
  "Parking only in designated areas (any fines resulting from this to be borne by the hirer).",
  "Cars are not decorated.",
  "Self-driven cars do not come with a luggage carrier.",
  "If any accident happens due to valet parking, then the customer will be responsible for it.",
];

const TermsAndConditionsDialog = () => {
  const [openDialog, setOpenDialog] = useState(false);

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return (
    <div>
       <Box display="flex" justifyContent="center" alignItems="center" sx={{ mb: 2 }}>
       <Button
          variant="outlined"
          color="black"
          onClick={handleOpenDialog}
          sx={{
            padding: '16px 16px', // Adjusted padding
            fontSize: '1rem', // Font size
            background:'#5585b5',
            color:'white',
            borderRadius:'8px',
          }}
        >
          Click Here To View Terms and Conditions
        </Button>
      </Box>
      <CommonDialog
        open={openDialog}
        onClose={handleCloseDialog}
        title="Terms and Conditions"
      >
        <Typography variant="body1" sx={{ mb: 2 }}>
          Please read the following terms and conditions carefully before renting a vehicle.
        </Typography>
        <List sx={{ padding: 0 }}>
          {termsAndConditions.map((item, index) => (
            <ListItem key={index} sx={{ padding: 0 }}>
              <ListItemText primary={`• ${item}`} />
            </ListItem>
          ))}
        </List>
      </CommonDialog>
    </div>
  );
};

export default TermsAndConditionsDialog;
